<template>
  <div class="container-fluid">
    <h1 class="detail-title">
      <i id="sidebar" class="fa fa-bars" @click="toggleSidebar"></i>
      User Details
    </h1>
    <div id="card">
      <div class="card-section">
        <popups></popups>  
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">First Name</p>
            <input id="user-first-name" type="text" name="name" 
              v-on:blur="fieldWatcher($event)" :value="selectedUser.first_name" 
              :disabled="! canEdit" />
          </div>
           <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Last Name</p>
            <input id="user-last-name" type="text" name="name" 
              v-on:blur="fieldWatcher($event)" :value="selectedUser.last_name" 
              :disabled="! canEdit" />
          </div>
        </div>
        
        <div class="row section-body">
          <div class="col-sm-2 section-property-block">
            <p class="section-property-title">Username</p>
            <input id="user-username" type="text" name="name" 
              v-on:blur="fieldWatcher($event)" :value="selectedUser.username" 
              :disabled="! canEdit" />
            </div>
        </div>
        
        <div class="row section-body role-permissions">
          <div class="col-sm-4 section-property-block">
            <p class="section-property-title">Email</p>
            <input id="user-email" type="text" name="name" 
              v-on:blur="fieldWatcher($event)" :value="selectedUser.email" 
              :disabled="! canEdit" />
            </div> 
        </div>
        
        <div class="row section-body role-permissions">
          <div class="col-sm-5 section-property-block">
            <p class="section-property-title">Organization</p>
            <multi-select v-model="organizations" label-key="name"
                          value-key="id" :options="all_organizations"
                          :limit="1" filterable block 
                          :disabled="! canEdit" />
          </div>
        </div>
        
        <div class="row section-body role-permissions">
          <div class="col-sm-5 section-property-block">
            <p class="section-property-title">Groups</p>
            <multi-select v-model="groups" label-key="name" value-key="id"
              :options="all_groups" :limit="1"
              filterable block 
              :disabled="! canEdit" />
          </div>
        </div>
  
        <div class="card-section sub-section" v-if="canEdit" >
          <div class="row section-body button">
            <div class="col-sm-3 section-property-block">
              <btn type="primary" @click="submitUser()">Update</btn>
              <btn type="danger" @click="deleteUser()">Delete</btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import constants from '../../constants';
import store from '../../store.js';
import { bus } from '../../main';
import Vue from 'vue';
import moment from 'moment'
import Popups from '../Popups'
import { MultiSelect } from 'uiv'

export default {
  data () {
      return {
        fields: {},
        hasChanges: false,
        organizations: [],
        groups: [],
        message: { type: 'warning', title: 'User' },
      };
  },
  
  components: { MultiSelect, Popups },  
  computed: {
    ...mapState({

        selectedUser: function(state) {
          return state.selectedUser;
        },
        
        selectedUserId: function(state) {
          return state.selectedUser.id;
        },

      all_organizations: function(state) {
          let id, list = [];
          let data = state.organizations;
          let selectedOrganizations = this.selectedUser.organizations;

          if (data != undefined) {
            data.forEach(function(_data) {
              if (selectedOrganizations != undefined) {
                for(var i=0; i < selectedOrganizations.length; i++) {
                  id = selectedOrganizations[i];
                  if (_data.id == id) list.push(_data.id);
                }
              }
            });
          }
          this.organizations=list;
          return data;
      },
      all_groups: function(state) {
          let id, list = [];
          let data = state.groups;
          let selectedGroups = this.selectedUser.groups;

          if (data != undefined) {
            data.forEach(function(_data) {
              if (selectedGroups != undefined) {
                for(var i=0; i < selectedGroups.length; i++) {
                  id = selectedGroups[i];
                  if (_data.id == id) list.push(_data.id);
                }
              }
            });
          }
          this.groups=list;
          return data;
      },
      canEdit: function(route){
        return store.getters.hasPerm('change_user');
      },
    }),
    
    ...mapGetters([ 'hasErrors', 'getErrors' ])
  },
  
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
    
    redirect: function(action) {
      if (action == 'delete')  this.$router.push('/users')
    },
    
    trimValue: function(value) {
      return (value != undefined || value != null)? value.trim() : value;
    },
    
    showPopup: function(value, type) {
      bus.$emit(type, { data: value });
    },
    
    checkCondition: function() {
      let result, counter = 0;
      let data = this.fields;
      
      for (var p in data)
        if(data.hasOwnProperty(p) )
          if (data[p] == 1) counter++;
     this.hasChanges = (counter > 0)? true : false; 
    },
    
    fieldWatcher: function(event) {
      let id = event.target.id;
      let key = id.split('-')[1];
      
      let group = this.selectedUser;
      let value = $("#" + id).val();
      
      if (this.trimValue(value) != group[key])this.fields[key] = 1;
      else this.fields[key] = 0;
      this.checkCondition();
    },
    
    confirmAction: function(data, action) {
      this.$confirm({
          title: 'Confirm Action',
          content: constants.message[action].action,
        }).then(() => {
          this.actionUser(data, action)
          }).catch(() => {
            this.$notify('Request has been cancelled.')
          });
    },
    
    actionUser: async function(data, action) {
      let failed = constants.message[action].failed;
      let success = constants.message[action].success;
      let response = await store.dispatch(((action == 'update')? 'updateUser' 
          : 'deleteUser'), { user: data }); 
      
      if(response === 'success' || response != undefined){
        this.message.type = 'success';
        this.message.content = success;
      } else {
        this.message.type = 'warning';
        this.message.content = failed;
      }

      this.showPopup(this.message, 'notification');
      this.redirect(action);
    },
    
    submitUser: async function() {
      let org_list = [];
      let all_orgs = this.all_organizations;

      let group_list = [];
      let all_groups = this.all_groups;
      
      let first_name = $("#user-first-name").val();
      let last_name = $("#user-last-name").val();
      let email = $("#user-email").val();
      let username = $("#user-username").val();
      let organizations = $("#user-organizations").val();
      let groups = $("#user-groups").val();


      console.log(first_name, first_name.length < 1)
      bus.$emit('reset', {});
      // if (first_name.length < 1) {
      //   store.dispatch('checkErrors', { message: 'A user name is required' });
      // }
      
      // get important field values from user options
      this.organizations.forEach(function(selected) {
        all_orgs.forEach(org => {
          if(org != undefined)
            if(org.id == selected)
              org_list.push(org.id);
        });
      }); 

      this.groups.forEach(function(selected) {
        all_groups.forEach(group => {
          if(group != undefined)
            if(group.id == selected)
              group_list.push(group.id);
        });
      }); 
      

      if (this.hasErrors) this.showPopup({'content': this.getErrors }, 'alert');
      else {
        this.confirmAction({
          'id': this.selectedUserId, 
          'first_name': this.trimValue(first_name), 
          'last_name': this.trimValue(last_name),
          'email': this.trimValue(email),
          'username': this.trimValue(username),
          'groups': group_list,
          'organizations': org_list
        }, 'update');
      }      
    },
    
    deleteUser: function () {
      let selectedUser = this.selectedUser;
      if (selectedUser != undefined)
        this.confirmAction(selectedUser, 'delete');
    },
    
    formatDateTime: function(data, format) {
      return (!data)? '--': moment(data).format(format);
    }
  },  
  beforeRouteEnter (to, from, next) {
    store.dispatch('setSelectedUser', { id: to.params.id });
    store.dispatch('fetchAllOrganizations');
    store.dispatch('fetchAllGroups');
    next();
  }
};
</script>

<style scoped lang="scss">
@import "../../css/constants";

h1.detail-title{
    background-color: #55bafc;
    padding: 20px;
    margin-left: -40px;
    margin-right: -40px;
    color: white;
    height: auto;
    margin-bottom: 25px;
}

.tool-tip{
  display: none;
  color: grey;
  background-color: #ececec;
  border-radius: 4px;
  position:absolute;
  margin-top: -40px;
  width: fit-content;
  padding-top:5px;
  padding-bottom:5px;
  padding-left: 5px;
  padding-right:5px;
  z-index: 100;
}
.tool-tip::after{
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ececec transparent transparent transparent;
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.section-property:hover{
  display: block;
}
.container-fluid {
    padding: auto;
}
.card-section {
  display: flex;
  flex-direction: column;
}

.col-padding { margin-bottom: 20px; }
.card-sub-body {
  margin-top: 20px !important;
  border-top: 1px solid #ddd;
  padding: 25px 0 0 0;
}

.section-body {
  display: flex;
  flex-wrap: wrap;
}
.section-title {
    font-family: 'Roboto Slab', serif;
    font-weight: bold;
    color: $gray7;
    font-size: $p20;
    line-height: $p20;
    margin-bottom: $p24;
}
.section-property-block {
  margin-right: $p16;
  margin-bottom: $p16;
  // min-width: 140px;
}
.section-property-title {
    position:relative;
    z-index:1;
    color: $gray5;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: $p14;
    line-height: $p14;
}
.section-property-container {
  height: $p32;
}
.section-property {
    color: $gray7;
    border:none;
    word-wrap: break-word;
    cursor: pointer;
    width: 100%;
}

.hor-padding{ display: block; margin-right: 110px !important; }
.detail-card-body{ background-color: white; }
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
//Reset Grid
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4,
.col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10,
.col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8,
.col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3,
.col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0 0 5px 0;
}
//Reset row
.row { margin: 0; }
.minus, .plus{
  border: 1px solid #cfcfcf;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  margin-top: 5px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 10px;
}
.plus > img{
  margin: auto;
}

@media only screen and (min-width: 768px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
  }
}

@media only screen and (min-width: 468px) and (max-width: 768px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
    i { display: inline-block; margin-right: 15px;  }
  }
}

@media only screen and (max-width: 467px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
    i { display: inline-block; margin-right: 15px; }
  } 
}
</style>




// WEBPACK FOOTER //
// src/components/user/UserDetail.vue